import React, { FC } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type CopyPriceListDialogProps = {
    open: boolean;
    handleClose: () => void;
    handleConfirm: () => void;
};

const CopyPriceListDialog: FC<CopyPriceListDialogProps> = ({
    open,
    handleClose,
    handleConfirm,
}: CopyPriceListDialogProps) => {
    const { t: translate } = useTranslation(['common', 'organization']);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="copy-pricelist-dialog-title"
            aria-describedby="copy-pricelist-dialog-description"
        >
            <DialogTitle id="copy-pricelist-dialog-title">{translate('organization:COPY_PRICELIST')}</DialogTitle>
            <DialogContent>
                <Typography>{translate('organization:COPY_PRICELIST_CONFIRMATION')}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>{translate('common:CANCEL')}</Button>
                <Button onClick={handleConfirm} variant="contained" autoFocus>
                    {translate('common:CONFIRM')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CopyPriceListDialog;
